import { defineMessages } from "react-intl"

export const messages = defineMessages({
    termsOfUse: {
      id: "footer.terms-of-use",
      defaultMessage: "Terms of use"
    },
    privacyPolicy: {
      id: "footer.privacy-policy",
      defaultMessage: "Privacy policy"
    },
    copyrightAndReuse: {
      id: "footer.copyright-and-reuse",
      defaultMessage: "Copyright & reuse"
    },
    usingTheSite: {
      id: "footer.using-the-site",
      defaultMessage: "Using the site"
    },
    contactUs: {
      id: "footer.contact-us",
      defaultMessage: "Contact us"
    },
    skipToContent: {
      id: "footer.skip-to-content",
      defaultMessage: "Skip to Content"
    }
  });

export default messages


// WEBPACK FOOTER //
// ./webapp/messages/footer.js